import Vue from 'vue'
import Component from 'vue-class-component'
import NumberCard from '@/components/Util/Layout/NumberCard/NumberCard.vue'
import vuescroll from 'vuescroll';

@Component({
  name: "PointsComponent",

  components: {
    NumberCard,
  },
})

export default class PointsComponent extends Vue {
  cx_vueScroll?: vuescroll

  cx_vueScrollOption = {
    vuescroll: {},
    scrollPanel: {
      initialScrollY: false,
      initialScrollX: '0%',
      scrollingX: true,
      scrollingY: false,
      speed: 300,
      easing: undefined,
      verticalNativeBarPos: 'right',
    },
    rail: {
      gutterOfEnds: '12px',
      background: '#D9E9E2',
      keepShow: true,
      specifyBorderRadius: '14px',
      size: '5px',
      opacity: '1',
    },
    bar: {
      background: '#C4C4C4',
      keepShow: true,
      opacity: 1,
      specifyBorderRadius: '14px',
      size: '5px',
    }
  }

  created() {
    this.cx_vueScroll = this.$refs['vs'] as vuescroll
  }
}
